
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.625 13.9c0 .138-.056.25-.125.25s-.125-.112-.125-.25.056-.25.125-.25M7.625 13.9c0 .138-.056.25-.125.25s-.125-.112-.125-.25.056-.25.125-.25M12.625 15.9c0 .138-.056.25-.125.25s-.125-.112-.125-.25.056-.25.125-.25M3.625 15.9c0 .138-.056.25-.125.25s-.125-.112-.125-.25.056-.25.125-.25M1.938 16.813c.069 0 .125.112.125.25","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill":"#F9B621","d":"M13 16.353l1.506-1.953 1.954 1.506-1.507 1.954zM7 15.853L8.507 13.9l1.953 1.506-1.507 1.954z"}}),_c('path',{attrs:{"fill":"#F9B621","d":"M4.608 17.336l.386-2.436 2.437.385-.386 2.437z"}}),_c('path',{attrs:{"d":"M9.625 16.938c0 .138-.056.25-.125.25s-.125-.112-.125-.25.056-.25.125-.25","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    